import React, { useCallback, useEffect, useState } from 'react'
import { StarAvaliation } from '../Employee/StarAvaliation/StarAvaliation'
import { Pill } from '../Employee/Pill/Pill'
import { EmployeeCompetenceView } from './employeeCompetenceView'
import { getEmployeePerformance } from '../../API/Employee/Employee'
import { NineBoxCompetence } from './9boxCompetence'
import { nineBoxCompetenceTranslate } from '../../i18n/translatedMessages'
import Loading from '../Loading/Loading'
import Assessment from '../../API/Assessment'

const mockCompetence = [
	{
		title: 'Organizacional',
		color: '#008acd',
		items: [
			{
				title: 'ORIENTACIÓN AL CLIENTE',
				text: 'La capacidad para encaminar todos los actos hacia la meta esperada, actuando con velocidad y sentido de urgencia ante decisiones importantes necesarias.',
			},
			{
				title: 'PENSAMIENTO ESTRATÉGICO',
				text: 'Es un proceso dinámico, flexible, que permite y hasta fuerza modificaciones en los planes, a fin de responder a las cambiantes circunstancias.',
			},
			{
				title: 'NEGOCIACIÓN EFECTIVA',
				text: 'Es un proceso en el que dos o más personas intercambian ideas con la intención de modificar sus relaciones y alcanzar un acuerdo tendiente a satisfacer necesidades mutuas.',
			},
			{
				title: 'CREATIVIDAD E INNOVACIÓN',
				text: 'La creatividad como habilidad para imaginar y conceptualizar ideas nuevas y originales, y la innovación como habilidad para que esas ideas se incorporen en nuestra vida, con el fin de hacerla más sencilla.',
			},
			{
				title: 'GESTIÓN EFECTIVA DEL TIEMPO',
				text: 'Habilidad para equilibrar las tareas diarias, fijando prioridades, con el fin de lograr una mayor productividad y eficiencia.',
			},
		],
	},

	{
		title: 'Social',
		color: '#6c4fdb',
		items: [
			{
				title: 'INCLUSIÓN Y DIVERSIDAD',
				text: 'La diversidad como el conjunto de características que nos hacen diferentes a los demás y la inclusión como la mezcla que hace que esas diferencias funcionen juntas.',
			},
			{
				title: 'COMUNICACIÓN EFECTIVA',
				text: 'Es la capacidad de escuchar, comprender e interpretar de manera correcta la información de otro y a la vez de transmitir de manera adecuada, asegurándose de que el mensaje sea recibido.',
			},
			{
				title: 'RELACIONES INTERPERSONALES',
				text: 'Las relaciones implican gestionar emociones positivas y negativas, propias y de otros, con el fin de enfrentarse a sucesos desagradables y también a sucesos emocionantes.',
			},
			{
				title: 'TRABAJO EN EQUIPO',
				text: 'Capacidad de lograr objetivos compartidos por todos los integrantes de manera consciente, mancomunada, coordinada y colaborativa.',
			},
			{
				title: 'ORIENTACIÓN A RESULTADOS',
				text: 'La capacidad para encaminar todos los actos hacia la meta esperada, actuando con velocidad y sentido de urgencia ante decisiones importantes necesarias.',
			},
		],
	},

	{
		title: 'Líder',
		color: '#00a28b',
		items: [
			{
				title: 'VISIÓN INSPIRADORA',
				text: 'Actitud de curiosidad y apertura, con el fin de lograr un aprendizaje de cada situación a lo largo de la vida.',
			},
			{
				title: 'TOMA DE DECISIONES',
				text: 'Vivir significa elegir; no tomar decisiones implica inmovilidad y bloqueo. Muchas veces funciona la intuición: tomar decisiones con el corazón y utilizar la mente para que funcionen.',
			},
			{
				title: 'GESTIÓN DEL CAMBIO',
				text: 'La gestión del cambio busca facilitar y conseguir la implementación exitosa de los procesos de transformación, lo que implica trabajar con y para las personas en la aceptación y asimilación de los cambios y en la reducción de la resistencia a los mismos.',
			},
			{
				title: 'LÍDER COACH',
				text: 'Busca mostrar nuevas posibilidades a sus equipos, ayudándolos a tomar decisiones que antes no eran obvias para ellos.',
			},
		],
	},

	{
		title: 'Persona',
		color: '#d87706',
		items: [
			{
				title: 'RESILIENCIA',
				text: 'Las personas que lo son no creen que exista una vida dura, sino momentos difíciles.',
			},
			{
				title: 'FLEXIBILIDAD',
				text: 'Habilidad de reconocer un entorno en el cual lo único constante es el cambio y a su vez, tener la plasticidad para adaptar las conductas, decisiones, estrategias, y relaciones a dicho entorno y sus necesidades.',
			},
			{
				title: 'APRENDIZAJE CONTINUO',
				text: 'Se refiere a la actitud de curiosidad y apertura para el aprendizaje a lo largo de la vida.',
			},
			{
				title: 'EMPATÍA',
				text: 'Es el arte consciente de crear puentes de vulnerabilidad y compasión `con` y `para` el otro.',
			},
			{
				title: 'BALANCE DE VIDA PERSONAL-LABORAL',
				text: 'Armonía entre el desarrollo profesional y las metas personales, con el fin de que el ser humano se siente protagonista de su destino y bienestar integral.',
			},
			{
				title: 'AUTOCONOCIMIENTO',
				text: 'Capacidad para percibirse a uno mismo y al entorno de una manera consciente.',
			},
		],
	},
]

export function AccordionItem({ isOpen, setIsOpen, employee }) {
	const [stars, setStars] = useState({
		competence: 0,
		performance: 0,
	})

	const [allScores, setAllScores] = useState(null)
	const [dimensions, setDimensions] = useState(null)
	const [mergedCompetence, setMergedCompetence] = useState([])
	const [loading, setLoading] = useState(false)
	const [cachedData, setCachedData] = useState({})
	const [isEvaluationOpen, setIsEvaluationOpen] = useState(false)
	const [isNineBoxOpen, setIsNineBoxOpen] = useState(false)

	const toggleAccordion = async () => {
		setIsOpen(prevIsOpen => !prevIsOpen)

		if (!isOpen && !cachedData[employee.id]) {
			await loadData(employee.id)
		}
	}

	const loadDimensions = async () => {
		try {
			setLoading(true)
			const [getDimensions, getPerformance] = await Promise.all([Assessment.getDimensions(employee.id), getEmployeePerformance(employee.id)])
			setDimensions(getDimensions)

			const averageScore = getDimensions.reduce((acc, dimension) => acc + dimension.score_relative, 0) / 4
			const competenceValue = averageScore / 20

			setStars(prev => ({
				...prev,
				competence: competenceValue,
				performance: getPerformance?.body?.boxPerformance,
			}))
		} catch {
			console.error('Erro ao carregar os dados')
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (employee.status) {
			loadDimensions()
		}
	}, [employee.status])

	const loadData = async employeeId => {
		try {
			setLoading(true)
			const [getAllScore] = await Promise.all([Assessment.getStrengthWeaknessAllScore(employeeId)])
			setAllScores(getAllScore)

			merge(dimensions, getAllScore)
			setCachedData(prev => ({ ...prev, [employeeId]: true }))
		} catch {
			console.error('Erro ao carregar os dados')
		} finally {
			setLoading(false)
		}
	}

	const merge = (dimensions, allScores) => {
		const updatedCompetence = mockCompetence.map(competence => {
			const dimensionScore = dimensions?.find(dimension => dimension.dimension === competence.title)

			const updatedItems = competence?.items?.map(item => {
				const strengthScore = allScores?.strengths?.find(strength => strength.description === item.title)
				const weaknessScore = allScores?.weaknesses?.find(weakness => weakness.description === item.title)

				const score = strengthScore ? strengthScore.score : weaknessScore ? weaknessScore.score : null

				return {
					...item,
					score,
				}
			})

			return {
				...competence,
				score_relative: dimensionScore ? dimensionScore.score_relative : null,
				items: updatedItems,
			}
		})

		const sortedCompetence = updatedCompetence.sort((a, b) => (b.score_relative || 0) - (a.score_relative || 0))

		setMergedCompetence(sortedCompetence)
	}

	const calcProfile = () => {
		const valuePerformance = Number(stars.performance)
		const valueCompetence = Number(stars.competence)

		if (valueCompetence >= 0.1 && valueCompetence <= 3) {
			if (valuePerformance >= 0.1 && valuePerformance <= 3) {
				return {
					text: nineBoxCompetenceTranslate.competenceAvaliationPerfil1,
					color: '#FEE4E5',
				}
			} else if (valuePerformance >= 3.1 && valuePerformance <= 4) {
				return {
					text: nineBoxCompetenceTranslate.competenceAvaliationPerfil2,
					color: '#DFF3FE',
				}
			} else if (valuePerformance >= 4.1) {
				return {
					text: nineBoxCompetenceTranslate.competenceAvaliationPerfil3,
					color: '#C7FFF1',
				}
			}
		} else if (valueCompetence >= 3.1 && valueCompetence <= 4) {
			if (valuePerformance >= 0.1 && valuePerformance <= 3) {
				return {
					text: nineBoxCompetenceTranslate.competenceAvaliationPerfil4,
					color: '#FEE4E5',
				}
			} else if (valuePerformance >= 3.1 && valuePerformance <= 4) {
				return {
					text: nineBoxCompetenceTranslate.competenceAvaliationPerfil5,
					color: '#DFF3FE',
				}
			} else if (valuePerformance >= 4.1) {
				return {
					text: nineBoxCompetenceTranslate.competenceAvaliationPerfil6,
					color: '#C7FFF1',
				}
			}
		} else if (valueCompetence >= 4.1) {
			if (valuePerformance >= 0.1 && valuePerformance <= 3) {
				return {
					text: nineBoxCompetenceTranslate.competenceAvaliationPerfil7,
					color: '#FEF3C6',
				}
			} else if (valuePerformance >= 3.1 && valuePerformance <= 4) {
				return {
					text: nineBoxCompetenceTranslate.competenceAvaliationPerfil8,
					color: '#DFF3FE',
				}
			} else if (valuePerformance >= 4.1) {
				return {
					text: nineBoxCompetenceTranslate.competenceAvaliationPerfil9,
					color: '#C7FFF1',
				}
			}
		}

		return {
			text: 'S/A',
			color: '#FEE4E5',
		}
	}

	const calculatedText = calcProfile()

	return (
		<div className={`tw-divide-y ${!employee.status ? 'tw-pointer-events-none tw-bg-gray-50' : ''}`}>
			<div
				className={`tw-cursor-pointer tw-transition-all ${
					isOpen ? 'tw-bg-purple-500' : 'tw-bg-white'
				} tw-flex tw-justify-between tw-items-center tw-w-full tw-p-4 tw-text-left tw-text-gray-800 tw-font-medium tw-focus:outline-none ${
					!employee.status ? 'tw-bg-gray-50 tw-text-gray-400' : ''
				}`}
				onClick={employee.status ? toggleAccordion : undefined}
			>
				<div className='tw-flex tw-items-center tw-justify-between'>
					<img
						src={employee.profileImg ?? 'https://assets.mydna.company/profile-placeholder.png'}
						alt=''
						className='img-fluid rounded-circle tw-w-[64px] tw-h-[64px]'
					></img>
					<div className='tw-flex tw-flex-col tw-ml-5 tw-h-full'>
						<span className={`${isOpen && employee.status ? 'tw-text-white' : 'tw-text-gray-800'} tw-text-md tw-font-bold tw-mb-1`}>
							{employee.name}
						</span>
						<span className={`${isOpen && employee.status ? 'tw-text-white' : 'tw-text-gray-400'}`}>{employee.jobName}</span>
					</div>
				</div>
				<div className='tw-flex tw-items-center tw-space-x-8' style={{ overflow: 'hidden', width: '450px' }}>
					<StarAvaliation label={nineBoxCompetenceTranslate.competenceAvaliationLabel} value={stars.competence} eventColorText={isOpen} />
					<div className='tw-flex-grow'>
						<Pill label={'Perfil'} text={calculatedText.text} color={`tw-bg-[${calculatedText.color}]`} eventColorText={isOpen} />
					</div>
					<div className='tw-flex tw-justify-center tw-items-center'>
						<svg
							className={`tw-w-5 tw-h-5 tw-transition-all ${isOpen ? 'tw-rotate-180' : 'tw-rotate-0'}`}
							fill='none'
							stroke='currentColor'
							viewBox='0 0 24 24'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M19 9l-7 7-7-7'></path>
						</svg>
					</div>
				</div>
			</div>
			<div className={`tw-overflow-hidden tw-transition ${isOpen ? 'tw-max-h-full' : 'tw-max-h-0'}`}>
				<div className='tw-p-4 tw-bg-purple-200'>
					<div className='tw-p-4 tw-bg-white'>
						<div className='tw-cursor-pointer' onClick={() => setIsEvaluationOpen(prev => !prev)}>
							{nineBoxCompetenceTranslate.competencyTest}
						</div>
						<div className={`tw-overflow-hidden tw-transition ${isEvaluationOpen ? 'tw-max-h-full' : 'tw-max-h-0'}`}>
							<div className='tw-text-black tw-my-5 tw-text-sm'>{nineBoxCompetenceTranslate.competenceAvaliationDesc}</div>
							{loading && <Loading />}
							{isEvaluationOpen && !loading && <EmployeeCompetenceView mergedCompetence={mergedCompetence} />}
						</div>
					</div>

					<div className='tw-p-4 tw-bg-white tw-mt-2'>
						<div className='tw-cursor-pointer' onClick={() => setIsNineBoxOpen(prev => !prev)}>
							9box {nineBoxCompetenceTranslate.competenceAvaliation9Box}
						</div>
						<div className={`tw-overflow-hidden tw-transition ${isNineBoxOpen ? 'tw-max-h-full' : 'tw-max-h-0'}`}>
							{isNineBoxOpen && <NineBoxCompetence stars={stars} chart={true} />}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export function AccordionEmployeeCompetences({ children, employeesList }) {
	const [openIndex, setOpenIndex] = useState(null)

	const handleAccordionClick = index => {
		setOpenIndex(prevIndex => (prevIndex === index ? null : index))
	}

	return (
		<div className='tw-shadow-md tw-border-black tw-rounded-lg tw-w-full tw-mt-10 tw-overflow-hidden'>
			{employeesList && employeesList.length > 0 ? (
				employeesList.map((employee, index) => (
					<AccordionItem employee={employee} key={index} isOpen={index === openIndex} setIsOpen={() => handleAccordionClick(index)}>
						{children}
					</AccordionItem>
				))
			) : (
				<p>Nenhum funcionário encontrado.</p>
			)}
		</div>
	)
}

export default AccordionEmployeeCompetences
